import React from "react";
import { ArrowRight } from "lucide-react";
import { FOUNDER_AVATARS } from "../data/mock";

export default function Hero() {
  return (
    <section className="pt-[180px] pb-16">
      <div className="container-x text-center">
        {/* Eyebrow */}
        <div
          className="hero-enter hero-enter-eyebrow inline-flex items-center gap-2 px-4 py-2 rounded-full mb-8"
          style={{
            background: "rgba(255, 51, 1, 0.1)",
            color: "var(--agero-orange)",
          }}
        >
          <span
            className="w-1.5 h-1.5 rounded-full"
            style={{ background: "var(--agero-orange)" }}
          />
          <span className="text-[13px] font-medium tracking-wide">
            LinkedIn GTM Partner for B2B Founders
          </span>
        </div>

        {/* Headline */}
        <h1
          className="hero-title mx-auto hero-enter hero-enter-h1"
          style={{
            fontSize: "clamp(40px, 6.2vw, 96px)",
            maxWidth: "1180px",
          }}
        >
          <span>Done-for-you content.</span>
          <br />
          <span className="gradient-orange-text glow-pulse">
            Built-for-you inbound.
          </span>
        </h1>

        {/* Subheadline */}
        <p
          className="mt-10 text-[18px] text-neutral-600 mx-auto leading-relaxed hero-enter hero-enter-sub"
          style={{ maxWidth: 680 }}
        >
          We build the entire LinkedIn revenue system. Content,
          conversion layer, and pipeline infrastructure.
        </p>

        {/* CTAs */}
        <div className="mt-10 flex items-center justify-center gap-5 flex-wrap hero-enter hero-enter-cta">
          <a href="#booking" className="btn-pill">
            Book a Discovery Call
            <span className="arrow">
              <ArrowRight size={14} />
            </span>
          </a>
          <a
            href="#services"
            className="text-[15px] font-medium text-neutral-800 hover:text-[color:var(--agero-orange)] transition-colors"
          >
            See how it works &rarr;
          </a>
        </div>

        {/* Trust avatars */}
        <div className="mt-14 flex items-center justify-center gap-3 hero-enter hero-enter-trust">
          <div className="flex -space-x-2">
            {FOUNDER_AVATARS.map((src, i) => (
              <img
                key={i}
                src={src}
                alt="founder"
                className="w-8 h-8 rounded-full border-2 border-[#EBEBEB] object-cover"
              />
            ))}
          </div>
          <span className="text-[14px] text-neutral-600">
            Trusted by B2B founders.
          </span>
        </div>
      </div>
    </section>
  );
}
